// SurveyFormReview show users their form inputs for review
import React from 'react';
import {connect} from 'react-redux';
import formFields from './formFields';
import * as actions from '../../actions';
import { withRouter  } from 'react-router-dom';

const SurveyFormReview = ({ onCancel, submitSurvey, formValues, history }) => {
    const reviewFields = formFields.map(field => {
        return (
            <div key={field.name}>
                <label>{field.label}</label> 
                <div>{formValues[field.name]}</div>
            </div>
        );
    });


    return (
        <div>
            <h5>Please confirm your entries</h5>
            {reviewFields}
            {/* <div> refactor for array from FIELDS array
                <div>
                   <label>Survey Title</label> 
                   <div>{formValues.title}</div>
                </div>
                <div>
                   <label>Subject Line</label> 
                   <div>{formValues.subject}</div>
                </div>
                <div>
                   <label>Email Body</label> 
                   <div>{formValues.body}</div>
                </div>
            </div> */}
            <button
                onClick={onCancel}
                className='yellow darken-3 white-text btn-flat'
            >
                Back
            </button>
            <button
                onClick={() => submitSurvey(formValues, history)}
                className='green white-text btn-flat right'
            >
                Send Survey
                <i className='material-icons right'>email</i>
            </button>
        </div>
    );
};

function mapStateToProps(state) { // pull values from redux, mapstate and connect 
    //console.log(state, 'redux state');
    return {
        formValues: state.form.surveyForm.values // whatever we put in connect map state to props return formValues, will show in our SurveyFormReview component as props
    }
}

// connect gives us redux state access, and withrouter gives us router helpers
export default connect(mapStateToProps, actions)(withRouter(SurveyFormReview));